import { render, staticRenderFns } from "./rangaistustaulukko.vue?vue&type=template&id=aa18bad0&scoped=true&"
import script from "./rangaistustaulukko.vue?vue&type=script&lang=js&"
export * from "./rangaistustaulukko.vue?vue&type=script&lang=js&"
import style0 from "./rangaistustaulukko.vue?vue&type=style&index=0&id=aa18bad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa18bad0",
  null
  
)

export default component.exports